module.exports = __webpack_public_path__ + "assets/f9310dd1e11f08d5057b19ba22e4db7b.mp3";